// Search functionality
const openSearch = document.querySelector("#open-search");
const search = document.querySelector(".header-search");
const navBackground = document.querySelector(".background-blur");

// Only run if the open search button exists (for toggle functionality)
if (openSearch && search && navBackground) {
  openSearch.addEventListener("click", () => {
    const isActive = search.classList.contains("active");

    if (isActive) {
      // Close search
      search.classList.remove("active");
      openSearch.setAttribute("aria-expanded", "false");
      openSearch.classList.remove("active");
      navBackground.classList.remove("active");
    } else {
      // Close menu if open
      const hamburger = document.getElementById("hamburger");
      const nav = document.getElementById("nav");
      if (hamburger && nav && hamburger.getAttribute("aria-expanded") === "true") {
        nav.classList.remove("open");
        nav.setAttribute("aria-hidden", "true");
        hamburger.setAttribute("aria-expanded", "false");
      }

      // Remove menu-active class from header
      const header = document.querySelector("header");
      if (header) {
        header.classList.remove("menu-active");
      }

      // Open search
      search.classList.add("active");
      openSearch.setAttribute("aria-expanded", "true");
      openSearch.classList.add("active");
      navBackground.classList.add("active");
      // Focus the search input when opened
      const searchInput = search.querySelector("#search");
      if (searchInput) {
        searchInput.focus();
      }
    }
  });
}

// Close search on escape key
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && search && search.classList.contains("active")) {
    search.classList.remove("active");
    if (openSearch) {
      openSearch.setAttribute("aria-expanded", "false");
      openSearch.classList.remove("active");
      navBackground.classList.remove("active");
    }
  }
});

// Close search when clicking outside
document.addEventListener("click", (e) => {
  if (search && search.classList.contains("active")) {
    // Check if click is outside the search area and not on the open search button
    const isClickInsideSearch = search.contains(e.target);
    const isClickOnOpenButton = openSearch && openSearch.contains(e.target);

    if (!isClickInsideSearch && !isClickOnOpenButton) {
      search.classList.remove("active");
      if (openSearch) {
        openSearch.setAttribute("aria-expanded", "false");
        openSearch.classList.remove("active");
        navBackground.classList.remove("active");
      }
    }
  }
});
